import moment from 'moment'

export default (value, short = false) => {
  const date = moment(value)
  return date.format('DD.MM.YY' + (short ? '' : 'YY'))
}



// WEBPACK FOOTER //
// ./src/filters/date.js